import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import type {  AxiosRequestConfig } from "axios";

export enum SettingEndpoints {
  SETTING_MIX = "setting/mix",
}

export class SettingService {
  static getSettingsMix(config?: AxiosRequestConfig) {
    return request({
      url: SettingEndpoints.SETTING_MIX,
      method: AxiosMethod.GET,
      params: config?.params,
    });
  }
}
